<ion-app>
<!--  <ion-split-pane>-->
<!--    <ion-menu type="overlay">-->
<!--      <ion-header>-->
<!--        <ion-toolbar color="primary">-->
<!--          <ion-title>Menu</ion-title>-->
<!--        </ion-toolbar>-->
<!--      </ion-header>-->
<!--      <ion-content>-->
<!--        <ion-list class="menu" [colorLuminance]="{ color: color, percent: pages.indexOf(pages[pages.length - 1]) * 3, rgbHex: true }">-->
<!--          <ion-menu-toggle auto-hide="false">-->
<!--            <div-->
<!--              class="item"-->
<!--              menuClose-->
<!--              *ngFor="let page of pages; let i = index"-->
<!--              (click)="openPage(page)"-->
<!--              [ngStyle]="{ height: 100 / pages.length + '%' }"-->
<!--              [colorLuminance]="{ color: color, percent: i * 3, rgbHex: true }"-->
<!--            >-->
<!--              <ion-icon *ngIf="!page.image" src="../assets/icon/{{ page.icon }}.svg"></ion-icon>-->
<!--              <div class="image" *ngIf="page.image" [image-loader]="page.icon"></div>-->
<!--            </div>-->
<!--          </ion-menu-toggle>-->
<!--        </ion-list>-->
<!--      </ion-content>-->
<!--    </ion-menu>-->
    <ion-router-outlet main></ion-router-outlet>
<!--  </ion-split-pane>-->
</ion-app>
